{
  "states": {
    "loading": "Yükleniyor...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Açık",
    "Clouds": "Bulutlu",
    "Rain": "Yağmurlu",
    "Drizzle": "Çiseleme",
    "Thunderstorm": "Gök gürültülü fırtına",
    "Snow": "Karlı",
    "Mist": "Pus",
    "Smoke": "Duman",
    "Haze": "Sis",
    "Dust": "Toz",
    "Fog": "Sis",
    "Sand": "Kum",
    "Ash": "Kül",
    "Squall": "Bora",
    "Tornado": "Kasırga"
  },
  "modal": {
    "defaultTitle": "Hava Durumu",
    "subtitle": "Mevcut koşullar",
    "showFahrenheit_aria": "Fahrenhayt göster",
    "showCelsius_aria": "Santigrat göster",
    "switchToCelsius_title": "°C'ye geç",
    "switchToFahrenheit_title": "°F'ye geç",
    "feelsLike": "Hissedilen {{temp}}°{{unit}}",
    "humidityWind": "Nem %{{humidity}} · Rüzgar {{wind}}",
    "windSpeed": "{{speed}} mil/sa",
    "hourlyNow": "Şimdi",
    "hourlyOffset": "{{hours}} sa",
    "hourlyStrip_aria": "Saatlik sıcaklık",
    "hourlyLocked": "Saatlik tahmin bir Pro özelliğidir.",
    "statsLocked": "Hava durumu detayları bir Pro özelliğidir.",
    "stats": {
      "sunrise": "Gün doğumu",
      "sunset": "Gün batımı",
      "feels": "Hissedilen",
      "humidity": "Nem",
      "wind": "Rüzgar",
      "rain": "Yağmur"
    },
    "rainInches": "{{value}} inç",
    "forecastTitle": "5 Günlük Tahmin",
    "forecastLoading": "Tahmin yükleniyor…",
    "forecastUnavailable": "Tahmin kullanılamıyor",
    "forecastLocked": "5 günlük tahmin bir Pro özelliğidir.",
    "forecastRow_aria": "Beş günlük tahmin",
    "proHeadline": "Tam hava tahmini Pro'nun bir parçasıdır.",
    "proFeatures": "Saatlik · Ayrıntılı koşullar · 5 günlük görünüm."
  }
}
